module.exports = __webpack_public_path__ + "static/media/1_shipping@2x.72c36c94.jpg";